import { useEffect, useState } from 'react'
import { consumirApi } from '../../../utils/consumoApi'
import { agregarDatosEmpresaUsuario } from '../../../utils/empresaUsuario'
import ErrorAlert from '../../../components/common/ErrorAlert'
import Table from '../../../components/tables/TableFilter'
import Button from '../../../components/common/Button'
import Modal from '../../../components/modals/Modal'
import ModalConfirmacion from '../../../components/modals/ModalConfirmacion'
import Form from '../../../components/forms/Form'
import Input from '../../../components/common/Input'
import Notification from '../../../components/common/Notification'
import Spinner from '../../../components/common/Spinner'

const TipoTerreno = () => {
    const [datos, setDatos] = useState([])
    const idEmpresa = JSON.parse(localStorage.getItem('empresa'))
    // campos 
    const [idTipoTerreno, setIdTipoTerreno] = useState("")
    const [tipoTerreno, setTipoTerreno] = useState("")
    // modales 
    const [mostrarModal, setMostrarModal] = useState(false)
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false)
    const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false)
    // notificaciones y cargas 
    const [cargando, setCargando] = useState(true)
    const [error, setError] = useState("")
    const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
    const [isSubmitting, setIsSubmitting] = useState(false)
    //seleccion de fila
    const [selectedId, setSelectedId] = useState(null)
    //datos para la tabla
    const columnas = [
        { titulo: 'Tipo terreno', campo: 'tipo_terreno' },
    ]

    // Carga inicial de los tipos de terreno
    useEffect(() => { obtenerTiposTerreno() }, [])

    // Función para traer los tipos de terreno
    const obtenerTiposTerreno = async () => {
        const respuesta = await consumirApi('GET', `maestros/tipo-terreno/${idEmpresa}`)
        setDatos(respuesta.success ? respuesta.data : respuesta.error)
        setCargando(false)
    }

    //Funcion para registrar nuevo tipo de terreno
    const registrarTipoTerreno = (async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        agregarDatosEmpresaUsuario(formData)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', `maestros/tipo-terreno`, formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "Tipo de terreno registrado correctamente" })
            limpiarCampos()
            obtenerTiposTerreno()
        }
        else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    })

    // funcion para abrir el modal para editar tipo de terreno 
    const abrirModalEditar =(data) => {
        setIdTipoTerreno(data.id)
        setTipoTerreno(data.tipo_terreno)
        setMostrarModalEditar(true)
    }

    // Edición de tipo de terreno
    const enviarEdicionTipoTerreno = async (e) => {
        e.preventDefault()
        const data = { tipo_terreno: tipoTerreno }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `maestros/tipo-terreno/${idTipoTerreno}`, data)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Tipo de terreno actualizado correctamente" })
            limpiarCampos()
            obtenerTiposTerreno()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Manejar selección de checkbox
    const seleccionTipoTerreno = (data) => {
        setSelectedId((prevSelectedId) => (prevSelectedId === data.id ? null : data.id))
    }

    // funcion para abrir el modal para editar TipoTerreno
    const eliminarTipoTerreno = async () => {
        const respuesta = await consumirApi('DELETE', `maestros/tipo-terreno/${selectedId}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Tipo de terreno eliminado correctamente" })
            limpiarCampos()
            obtenerTiposTerreno()
        } else {
            setError(respuesta.error)
        }
    }

    const limpiarCampos = () => {
        setError('')
        setSelectedId(null)
        setTipoTerreno('')
        setMostrarModal(false)
        setMostrarModalEditar(false)
        setMostrarModalEliminar(false)
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }

    return (
        <div className='w-full min-h-[calc(100vh-50px)]'>
            <Button className="ml-5 mt-2" texto='+ Nuevo' onClick={() => setMostrarModal(true)} />
            <Button className="ml-3 mt-2"  type="delete" disabled={!selectedId} onClick={()=>setMostrarModalEliminar(true)} />
            {notificacion.estado && (
                <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
            )}
            {cargando ? (
                <Spinner />
            ) : (
                datos.length === 0 ? (
                    <div className="ml-5">No se encontraron tipos de terreno</div>
                ) : (
                    <Table datos={datos} listaCampos={columnas} editarRegistro={abrirModalEditar}
                        mostrarChecks={true}
                        seleccionFila={seleccionTipoTerreno} // Manejar el ID seleccionado
                        selectedId={selectedId} // Manejar el ID seleccionado
                    />
                )
            )}

            {/* Modal Registrar nuevo Tipo de terreno*/}
            <Modal isOpen={mostrarModal} title="Registrar nuevo tipo de terreno" onClose={limpiarCampos} >
                <Form onSubmit={registrarTipoTerreno} isSubmitting={isSubmitting}>
                    <Input name="tipo_terreno" value={tipoTerreno} label="Tipo de terreno" onChange={setTipoTerreno} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal Actuazliar nuevo Tipo de terreno*/}
            <Modal isOpen={mostrarModalEditar} title="Actualizar tipo de terreno" onClose={limpiarCampos} >
                <Form onSubmit={enviarEdicionTipoTerreno}  isSubmitting={isSubmitting} type='update'>
                    <Input name="tipo_terreno" value={tipoTerreno} label="Tipo de terreno" onChange={setTipoTerreno} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal de confirmación para eliminar un tipo de terreno*/}
            <ModalConfirmacion
                isOpen={mostrarModalEliminar}
                onClose={limpiarCampos}
                onConfirm={eliminarTipoTerreno}
                mensaje="¿Estás seguro de que deseas eliminar el tipo de terreno?"
            >
                {error && <ErrorAlert message={error} />}
            </ModalConfirmacion>

        </div>
    )
}

export default TipoTerreno
